import { BACKEND_URL } from "./lib/backend";
export const API = `${BACKEND_URL}/api`;
